import actionTypes from "./actionTypes.js";
import namespace from './namespace';
export default {
  namespace,
  state: {
    isBottom: false
  },
  reducers: {
    [actionTypes.GET_ISBOTTOM](state, action) {
      return { ...state,
        isBottom: action.data
      };
    }

  }
};